import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { prettyDOM } from "@testing-library/react";

const orderData = async (data, configChart, ordering) => {
  let orderedData = await data.sort(dynamicSort(ordering.type+'-'+ordering.value));
  return orderedData;
}

const dynamicSort = (property) => {
  property = property.split('-');
  let sortOrder = 1;
  if(property[0] === "desc") {
      sortOrder = -1;
      
  }
  property = property[1];
  return function (a,b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
  }
}

const getRangeForZoom = (data, configChart, totalCols = 5) => {
  let range = {};
  if(data.length > totalCols){
    range = {
      min: data[data.length - totalCols][configChart.category],
      max: data[data.length - 1][configChart.category]
    }
  }else{
    range = {
      min: data[data.length - 1][configChart.category],
      max: data[0][configChart.category]
    }
  }
  return range;
}


const configTooltip = (series, config) => {
  
  series.tooltip.label.textAlign = config.textAlign ? config.textAlign : "middle";
  series.tooltip.pointerOrientation = config.pointerOrientation ? config.pointerOrientation: "down";
  series.tooltip.dy = config.dy ? config.dy: 0;
  series.tooltip.dx = config.dx ? config.dx: 0;
  // series.columns.template.alwaysShowTooltip = config.alwaysShowTooltip ? config.alwaysShowTooltip : false;
  series.tooltip.getFillFromObject = config.getFillFromObject ? config.getFillFromObject : false;
  if( !config.getFillFromObject ){
    series.tooltip.background.fill = config.color ? am4core.color(config.color) : am4core.color("#000");
  }
  return series;
}

const createSeries = async (chart, field, config, cont) => {
  let series = chart.series.push(new am4charts.ColumnSeries());
  series.dataFields.valueX = field;
  series.dataFields.categoryY = config.configChart.category;
  series.stacked = true;
  series.name = field;
  if(config.tooltip){
    series.columns.template.tooltipText = config.tooltip.text;
    series = await configTooltip(series, config.tooltip);
  }
  if(config.colors && Array.isArray(config.colors)){
    series.fill = am4core.color(config.colors[cont]);
    series.stroke = am4core.color(config.colors[cont]);
    
  }else{
    series.fill = chart.colors.getIndex(cont);
    series.stroke = chart.colors.getIndex(cont);
  }
}

const orderDataStackedBar = (data) =>{
  if(data && Array.isArray(data)){
    let keys = Object.keys(data[0]);
    let allKeys = [];
    let preOrdered = {};
    let ordered = [];
    let cont = 0;
    let category = keys[0];
    data.map((d) => {
      let category = d[keys[0]];
      let field = d[keys[1]];
      let value = d[keys[2]];
      if(!allKeys.includes(field)){
        allKeys.push(field);
      }
      if(preOrdered[d[keys[0]]] ){
        preOrdered[category][field] = value;
      }else{
        preOrdered[category] = {};
        preOrdered[category][field] = value;
      }
    })

    for(let category in preOrdered){
      let info = preOrdered[category];
      let obj = {
        ...info
      }
      obj[keys[0]] = category;
      ordered.push(obj);
    }
    return {
      ordered,
      allKeys,
      category
    }

  }
}

const getObjectWithFull = async (data, field) => {
  let mayor = 0;
  await data.map(async (d) => {
    mayor = await getMayorValue(mayor, d[field]);
  })

  data = await data.map((d) => {
    d["full"] = parseInt(mayor) + ( parseInt(mayor) / 2);
    return d;
  })
  return { data, mayor };
}

const getMayorValue = (oldValue, newValue) => {
  if(newValue > oldValue){
    return newValue;
  }else if(newValue <= oldValue){
    return oldValue;
  }
}

export {
  getRangeForZoom,
  orderData,
  configTooltip,
  createSeries,
  orderDataStackedBar,
  getObjectWithFull
}